import { PropsWithChildren } from 'react';

import { ArrowBackIosNew, MonitorHeartOutlined } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import MetaTags from 'src/components/Seo/MetaTags';
import TabTemplate from 'src/components/UI/TabTemplate';
import { ScrollToTop } from 'src/utils/scroll';

import { useMonitorContext } from './MonitorContextProvider';
import { MonitorGuestEnvironmentBanner } from './components/MonitorGuestEnvironmentBanner';

export function MonitorLayout({ children }: PropsWithChildren) {
  const { breadcrumbsItens, guestEnvironmentOwnerId } = useMonitorContext();
  const history = useHistory();
  const { pathname } = useLocation();

  const handleGoBack = () => {
    history.goBack();
  };

  const isViewPage =
    pathname.includes('/monitor/wallet/view/') ||
    pathname.includes('/monitor/wallet/following/');

  return (
    <ScrollToTop>
      <MetaTags title="Monitor Carteiras" description="" />

      <MonitorGuestEnvironmentBanner />

      <Box mt={guestEnvironmentOwnerId ? 8 : 0}>
        <TabTemplate
          title="Monitor"
          titleIcon={<MonitorHeartOutlined />}
          tabContent={[]}
          tabIndex={0}
          handleChange={() => {}}
          breadcrumbs={breadcrumbsItens}
        />

        {!isViewPage && (
          <Button
            variant="contained"
            color="inherit"
            sx={{
              position: 'relative',
              float: 'right',
              marginTop: '-84px',
              textTransform: 'uppercase',
              color: 'GrayText',
              '&:hover': {
                backgroundColor: 'grey.200',
              },
            }}
            startIcon={<ArrowBackIosNew />}
            onClick={handleGoBack}>
            Voltar
          </Button>
        )}

        {children}
      </Box>
    </ScrollToTop>
  );
}
